import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React from "react";
import { ReCaptchaProvider, ReCaptchaV2, ReCaptchaV3 } from "react-recaptcha-x";
import { Link } from "react-router-dom";
import { trackLoginForgotPasswordClicked } from "../../../../trackLoginEvents";
import * as S from "../styles";

type PasswordStepFormProps = {
  email: string;
  password: string;
  error: string;
  loading: boolean;
  disableButton: boolean;
  showPassword: boolean;
  enableRecaptchaV2: boolean;
  onPasswordChange: (password: string) => void;
  onTogglePassword: () => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  recaptchaV2Callback: (token: string) => void;
  recaptchaV3Callback: (token: string) => void;
};

export default function PasswordStepForm({
  email,
  password,
  error,
  loading,
  disableButton,
  showPassword,
  enableRecaptchaV2,
  onPasswordChange,
  onTogglePassword,
  onSubmit,
  recaptchaV2Callback,
  recaptchaV3Callback,
}: PasswordStepFormProps): React.ReactElement {
  return (
    <S.Form onSubmit={onSubmit}>
      <S.Field>
        <S.Label htmlFor="login-email">
          E-mail <S.Required>*</S.Required>
        </S.Label>
        <S.Input
          id="login-email"
          name="email"
          type="email"
          value={email}
          disabled
          autoComplete="email"
        />
      </S.Field>

      <S.Field>
        <S.Label htmlFor="login-password">
          Senha <S.Required>*</S.Required>
        </S.Label>
        <S.PasswordInputWrapper>
          <S.PasswordInput
            id="login-password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(event) => onPasswordChange(event.target.value)}
            autoComplete="current-password"
          />
          <S.TogglePasswordButton
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            onClick={onTogglePassword}
          >
            {showPassword ? (
              <VisibilityOffIcon
                fontSize="small"
                sx={{ color: "#6c757d !important" }}
              />
            ) : (
              <VisibilityIcon
                fontSize="small"
                sx={{ color: "#6c757d !important" }}
              />
            )}
          </S.TogglePasswordButton>
        </S.PasswordInputWrapper>
      </S.Field>

      <S.ForgotPasswordRow>
        <Link
          to="/forgot_password"
          onClick={trackLoginForgotPasswordClicked}
        >
          <S.RouterLink>Esqueci minha senha</S.RouterLink>
        </Link>
      </S.ForgotPasswordRow>

      <ReCaptchaProvider
        siteKeyV2={process.env.REACT_APP_RECAPTCHA_V2_SITEKEY}
        siteKeyV3={process.env.REACT_APP_RECAPTCHA_V3_SITEKEY}
      >
        {!enableRecaptchaV2 && (
          <ReCaptchaV3 callback={recaptchaV3Callback} action="login" />
        )}
        {enableRecaptchaV2 && (
          <ReCaptchaV2 callback={recaptchaV2Callback} className="mt-6" />
        )}
      </ReCaptchaProvider>

      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}

      <S.Button type="submit" disabled={loading || disableButton || !password}>
        {loading ? "Carregando..." : "Entrar"}
      </S.Button>
    </S.Form>
  );
}
